import { useEffect } from 'react';
import { SHELL_MQ } from '../../shared/tabletMedia';

const ACTIVE_CLASS = 'fi-scroll-page-active';
const TOUCH_SHELL_CLASS = 'naturals-touch-shell';

/**
 * Mobile/tablet scroll shell for face-identity pages.
 * Locks document scroll and scrolls the page root instead (iOS / Android WebView safe).
 * Matches phones and touch tablets up to 1366px landscape.
 */
export function useFaceIdentityScrollShell(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    const html = document.documentElement;
    const body = document.body;
    const mq = window.matchMedia(SHELL_MQ);

    const apply = () => {
      const on = mq.matches;
      html.classList.toggle(ACTIVE_CLASS, on);
      body.classList.toggle(ACTIVE_CLASS, on);
      html.classList.toggle(TOUCH_SHELL_CLASS, on);
      body.classList.toggle(TOUCH_SHELL_CLASS, on);
    };

    apply();
    mq.addEventListener('change', apply);

    return () => {
      mq.removeEventListener('change', apply);
      html.classList.remove(ACTIVE_CLASS, TOUCH_SHELL_CLASS);
      body.classList.remove(ACTIVE_CLASS, TOUCH_SHELL_CLASS);
    };
  }, [enabled]);
}
